import { Dispatch, FC, SetStateAction } from 'react'
import ReactCodeInput from '@acusti/react-code-input'
import Button from 'react-bootstrap/Button'

import { isIOS } from 'share/utils/isiOs'
import { VerifyUpdatedMobilePhoneVariables } from 'share/mutations/account'
import {
  CodeVerificationContainer,
  CodeVerificationSend,
  CodeVerifyWithinInfo,
  iOSCodeInputStyle
} from 'components/atoms/InputFields/CodeVerification'
import { ButtonsContainer } from 'components/features/dashboard/questionnaire/QuestionnareForm/styles'
import { TwoBtnsContainer } from 'components/atoms/Layout'

const style = !isIOS ? {} : iOSCodeInputStyle

interface Props {
  verifyUpdatedMobilePhoneHelper(
    verifyUpdatedMobilePhoneVariables: VerifyUpdatedMobilePhoneVariables
  ): void
  enteredCode: string
  enteredCodeComplete: boolean
  resendUpdatedMobilePhoneCodeHelper(): void
  setEnteredCode: Dispatch<SetStateAction<string>>
  setEnteredCodeComplete: Dispatch<SetStateAction<boolean>>
  cancelUpdatedMobilePhoneHelper(): void
}

const UserProfileVerifyMobilePhoneForm: FC<Props> = ({
  verifyUpdatedMobilePhoneHelper,
  enteredCode,
  enteredCodeComplete,
  resendUpdatedMobilePhoneCodeHelper,
  setEnteredCode,
  setEnteredCodeComplete,
  cancelUpdatedMobilePhoneHelper
}) => {
  const onSubmit = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault()

    const input: VerifyUpdatedMobilePhoneVariables = {
      verifyMobilePhoneData: {
        code: enteredCode
      }
    }
    verifyUpdatedMobilePhoneHelper(input)
  }

  const handleCodeChange = (val: string) => {
    if (val?.length === 6) {
      setEnteredCode(val)
      setEnteredCodeComplete(true)
      return
    }

    setEnteredCodeComplete(false)
  }

  async function onCancel() {
    cancelUpdatedMobilePhoneHelper()
  }

  return (
    <CodeVerificationContainer data-testid='user-profile-verify-phone-container'>
      <p>Please enter the verification code below.</p>
      <ReactCodeInput
        autoFocus
        className='ui-code-verification-inputs'
        fields={6}
        inputMode='numeric'
        inputStyle={style}
        name='verifyPhoneNumber'
        type='number'
        value={enteredCode}
        onChange={handleCodeChange}
      />
      <CodeVerifyWithinInfo>
        Please verify within 5 minutes.
      </CodeVerifyWithinInfo>
      <CodeVerificationSend data-testid='user-profile-verify-phone-send'>
        Didn't get a code?{' '}
        <span
          role='button'
          onClick={() => resendUpdatedMobilePhoneCodeHelper()}
          data-testid='user-profile-verify-phone-resend-code-button'
        >
          Send it again
        </span>
      </CodeVerificationSend>

      <ButtonsContainer
        className='p-0 btns-container'
        style={{ marginTop: '2rem' }}
      >
        <TwoBtnsContainer>
          <Button
            variant='outline-secondary'
            onClick={onCancel}
            className='ui-button-with-spinner'
            data-testid='user-profile-verify-phone-cancel-button'
          >
            Cancel
          </Button>
          <Button
            className='ui-button-with-spinner'
            disabled={!enteredCodeComplete}
            type='submit'
            onClick={onSubmit}
            data-testid='user-profile-verify-phone-next-button'
          >
            Next
          </Button>
        </TwoBtnsContainer>
      </ButtonsContainer>
    </CodeVerificationContainer>
  )
}

export default UserProfileVerifyMobilePhoneForm
